<h1 mat-dialog-title class="Title">詳細検索</h1>
<div mat-dialog-content fxLayout="column">
  <div fxFlex="auto">

    <mat-form-field>
      <span matPrefix>忘れ物発見場所分類 ： </span>
      <mat-select [(ngModel)]="foundPlaceCode">
        <mat-option *ngFor="let op of foundPlace" [value]="op.code">{{ op.codeName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    &nbsp;&nbsp;
    <mat-form-field>
      <span matPrefix>忘れ物保管分類 ： </span>
      <mat-select [(ngModel)]="storageCode">
        <mat-option *ngFor="let op of storage" [value]="op.code">{{ op.codeName }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    &nbsp;&nbsp;

    <button mat-raised-button color="primary" (click)="Search()">検索</button>
    &nbsp;
    <button mat-raised-button (click)="Clear()">クリア</button>

  </div>
</div>
<mat-dialog-actions align="end">
  <button mat-raised-button color="accent" (click)="CloseDialog()">戻る</button>
</mat-dialog-actions>
